import stylesheet from './ReasonCard.scss?inline';

import {NXTTextCard} from "../TextCard";

class NXTReasonCard extends NXTTextCard {

    constructor() {
        super();
        this.customStyle += stylesheet;
    }

    render() {
        const card = document.createElement('div');
        card.classList.add('text-card-container')
        card.innerHTML = `
            <div class="card">
                <div class="title"></div>
                <div class="body"></div>
                <div class="icon"></div>
            </div>
        `;
        this.cloneSlotContentIntoContainer(card.querySelector('.icon'), 'icon');
        this.cloneSlotContentIntoContainer(card.querySelector('.title'), 'title');
        this.cloneDefaultSlotContentIntoContainer(card.querySelector('.body'));
        return card;
    }

}

customElements.define('nxt-reason-card', NXTReasonCard);
